import { render, staticRenderFns } from "./ModalEditCustomer.vue?vue&type=template&id=63f59396&scoped=true&"
import script from "./ModalEditCustomer.vue?vue&type=script&lang=js&"
export * from "./ModalEditCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditCustomer.vue?vue&type=style&index=0&id=63f59396&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f59396",
  null
  
)

export default component.exports